module.exports = __webpack_public_path__ + "media/images/emblems/Presinge-coat_of_arms-466e904d986b67660aaa62bf7eb69462.svg";